import { Component } from "react";

// App-wide safety net: any unexpected render error shows a friendly panel instead of a blank screen.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Logged for diagnostics; no sensitive data is included here.
    console.error("Tradify render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-boundary" className="min-h-screen flex items-center justify-center bg-[var(--bg-canvas)] text-slate-300">
          <div className="text-center max-w-md px-6">
            <div className="text-lg font-semibold text-slate-100 mb-2">Something went wrong</div>
            <p className="text-sm text-slate-400 mb-4">A part of the interface failed to render. Your data is safe. Try reloading this view.</p>
            <button
              data-testid="error-boundary-reload"
              onClick={() => window.location.reload()}
              className="h-9 px-4 rounded-md bg-blue-600 hover:bg-blue-500 text-white text-sm"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
